import { PropType } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import { contractHoursToReadable } from '@/utils/tools';

type Props = SetupProps<typeof DashboardTempWorkerMissionSetupService.props>

export default class DashboardTempWorkerMissionSetupService extends BaseSetupService<Props> {
	static readonly props = {
		mission: {
			type: Object as PropType<IUpcomingTempWorkerContractModel>,
			default: undefined,
		},
	};

	readonly contractHoursToReadable = contractHoursToReadable;

	get missionPlace () {
		if (!this.props.mission) return;
		return `${this.props.mission.address}<br>${this.props.mission.postalCode} ${this.props.mission.city}`;
	}


	constructor (props?: Props) {
		super(props);
	}

	goToContract () {
		this.router.push({
			name: 'TempWorkerContractDetails',
			params: { id: this.props.mission?.id },
		});
	}
}
